import { createReducer, MetaReducer, on } from '@ngrx/store';
import { IDockingContext } from '../../../../model/docking';
import DockingActions from './docking.action-types';

export const dockingFeatureKey = 'docking';

export interface DockingState {
    dockingContext: IDockingContext;
    userMonitoring: boolean;
}

export const initialDockingState: DockingState = {
    dockingContext: {
        deviceId: '',
        state: '',
        stateName: '',
        messages: [],
        commands: [],
        conMonUsed: false,
        conMonActive: false,
        requiredMonitors: 0,
        aliveMonitors: 0,
        criticalCommands: [],
        info: { centerline: '', flight: '', acType: '' },
        cameraURL: '',
        gse: [],
        time: { timeString: '', timeType: '' },
        timeComparison: { time1: { timeString: '', timeType: '' }, time2: { timeString: '', timeType: '' } },
        inSelectionMenu: false,
        relatedCenterlineIds: [],
        usersMonitoring: []
    },
    userMonitoring: false
};

export const metaReducers: MetaReducer<DockingState>[] = [];

export const dockingContextReducer = createReducer(
    initialDockingState,

    on(DockingActions.loadDockingContext, (state, action) => {
        return {
            dockingContext: action.dockingContext,
            userMonitoring: state.userMonitoring
        };
    }),
    on(DockingActions.setUserMonitoring, (state, action) => {
        return { ...state, userMonitoring: action.userMonitoring };
    })
);
